import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "gift-box",
  "use": "gift-box-usage",
  "viewBox": "0 0 25 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 24\" id=\"gift-box\"><path clip-rule=\"evenodd\" d=\"M22.084 11.25h-19.5v10.5a1.5 1.5 0 001.5 1.5h16.5a1.5 1.5 0 001.5-1.5v-10.5zM22.084 6.75h-19.5a1.5 1.5 0 00-1.5 1.5v2.25c0 .414.336.75.75.75h21a.75.75 0 00.75-.75V8.25a1.5 1.5 0 00-1.5-1.5z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M11.584 6.75c-3.314 0-6.75-2.686-6.75-6M4.834.75c3.314 0 6.75 2.686 6.75 6M13.084 6.75c3.314 0 6.75-2.686 6.75-6M19.834.75c-3.314 0-6.75 2.686-6.75 6\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path clip-rule=\"evenodd\" d=\"M10.084 6.75h4.5v16.5h-4.5V6.75z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/gift-box.svg
// module id = wleA
// module chunks = 39 44